import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { ArrowLeft } from "lucide-react";
import TaskInfo from "./TaskInfo";

const ViewTaskDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const taskData = location.state?.data;

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      // Taller card when attachment tiles are shown so they stay inside it.
      height: taskData?.task_file_name ? 9 : 6,
      id: 2,
      component: <TaskInfo taskData={taskData} />,
      haveOverflowVisible: true,
    },
  ];

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 14px",
            borderRadius: "10px",
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
          }}
        >
          <ArrowLeft
            size={18}
            color="#fff"
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            View Task
          </div>
        </div>
        <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
          <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
            <GridItem layoutData={layoutData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTaskDetail;
